"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMenuPermissionEditModel = instanceOfMenuPermissionEditModel;
exports.MenuPermissionEditModelFromJSON = MenuPermissionEditModelFromJSON;
exports.MenuPermissionEditModelFromJSONTyped = MenuPermissionEditModelFromJSONTyped;
exports.MenuPermissionEditModelToJSON = MenuPermissionEditModelToJSON;
exports.MenuPermissionEditModelToJSONTyped = MenuPermissionEditModelToJSONTyped;
/**
 * Check if a given object implements the MenuPermissionEditModel interface.
 */
function instanceOfMenuPermissionEditModel(value) {
    return true;
}
function MenuPermissionEditModelFromJSON(json) {
    return MenuPermissionEditModelFromJSONTyped(json, false);
}
function MenuPermissionEditModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'mfNo': json['mfNo'] == null ? undefined : json['mfNo'],
        'mfMenuNo': json['mfMenuNo'] == null ? undefined : json['mfMenuNo'],
        'mfFunctionName': json['mfFunctionName'] == null ? undefined : json['mfFunctionName'],
    };
}
function MenuPermissionEditModelToJSON(json) {
    return MenuPermissionEditModelToJSONTyped(json, false);
}
function MenuPermissionEditModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'mfNo': value['mfNo'],
        'mfMenuNo': value['mfMenuNo'],
        'mfFunctionName': value['mfFunctionName'],
    };
}
